import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const blackoutDayApi = createApi({
    reducerPath: 'blackoutDayApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['blackoutDay'],
    endpoints: (builder) => ({
        saveBlackoutDate: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.BlackoutDateController.saveBlackoutDate}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,

                };
            },
        }),

        getBlackoutDates: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.BlackoutDateController.getBlackoutDates}${body.payload.parkingLocationId}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },

                };
            },
        }),

        updateBlackoutDate: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.BlackoutDateController.updateBlackoutDate}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,

                };
            },
        }),

    }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useSaveBlackoutDateMutation,
    useGetBlackoutDatesMutation,
    useUpdateBlackoutDateMutation,
} = blackoutDayApi;
